import React, { useEffect, useState } from "react";
import PageIntro from "../../Components/PageIntro/PageIntro";
import "./Gallery.css";

export default function Gallery() {
  const [index, setIndex] = useState(null);
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div>
      <PageIntro
        image={require("../../Assets/gall_img.jpg").default}
        text={"Picture Gallery"}
      />
      <div className="gallery">
        <div className="grid gridFr galleryContainer ">
          {[...Array(40)].map((x, i) => (
            <img
              src={require(`../../Assets/gallery/${i + 1}.jpg`).default}
              alt=""
              onClick={() => setIndex(i + 1)}
            />
          ))}
        </div>
      </div>
      {index && (
        <div className="liteBox" onClick={() => setIndex(null)}>
          <img
            src={require(`../../Assets/gallery/${index}.jpg`).default}
            alt=""
          />
        </div>
      )}
    </div>
  );
}
